<template>
  <div
    class="modal fade dq-modal"
    id="payroll_advance_regular_run_modal"
    tabindex="-1"
    aria-hidden="true"
    data-bs-backdrop="false"
    data-bs-keyboard="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content dq-modal-card">
        <div class="modal-body dq-advance-run-body">
          <div class="dq-advance-run-hero">
            <span class="dq-advance-run-badge">
              <i class="ti ti-alert-triangle"></i>
            </span>
          </div>

          <h4 class="mb-2 dq-advance-run-title">Mid-month advance already paid</h4>
          <p class="mb-0 dq-advance-run-subtitle">
            A mid-month advance has already been processed for
            <b>{{ periodLabel }}</b>.
          </p>

          <div class="dq-advance-run-note mt-3">
            <p class="mb-2">
              <strong>Standard Monthly Payroll</strong> will not recover that advance in full.
            </p>
            <p class="mb-0">
              For the closing run, use <strong>Month-End Final Payroll</strong> instead.
            </p>
          </div>

          <div class="d-flex justify-content-center flex-wrap gap-2 mt-4">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal">
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-outline-primary"
              @click="switchToFinal"
            >
              Use Final payroll
            </button>
            <button type="button" class="btn btn-warning" @click="confirmAnyway">
              Continue with Standard
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { Modal } from "bootstrap";

const emit = defineEmits(["confirmed", "switchToFinal"]);

const periodCode = ref("");

const periodLabel = computed(() => periodCode.value || "this month");

let modalInstance = null;

function getModal() {
  const el = document.getElementById("payroll_advance_regular_run_modal");
  if (!el) return null;
  modalInstance = Modal.getOrCreateInstance(el, { backdrop: false, keyboard: true });
  return modalInstance;
}

/** @param {{ periodLabel?: string }} payload */
function open(payload = {}) {
  periodCode.value = payload.periodLabel || "";
  getModal()?.show();
}

function hide() {
  modalInstance?.hide();
}

function confirmAnyway() {
  hide();
  emit("confirmed");
}

function switchToFinal() {
  hide();
  emit("switchToFinal");
}

defineExpose({ open, hide });
</script>

<style scoped>
.dq-advance-run-body {
  padding: 22px 20px 20px;
  text-align: center;
}
.dq-advance-run-hero {
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
}
.dq-advance-run-badge {
  width: 64px;
  height: 64px;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  background: rgba(245, 158, 11, 0.14);
  color: rgb(180, 83, 9);
}
.dq-advance-run-title {
  font-weight: 800;
  letter-spacing: -0.02em;
}
.dq-advance-run-subtitle {
  color: rgba(17, 24, 39, 0.68);
  font-size: 0.92rem;
  line-height: 1.45;
}
.dq-advance-run-note {
  text-align: left;
  padding: 10px 12px;
  border-radius: 14px;
  background: rgba(59, 130, 246, 0.08);
  border: 1px solid rgba(59, 130, 246, 0.12);
  color: rgba(30, 64, 175, 0.95);
  font-size: 0.84rem;
  line-height: 1.45;
}
</style>
